var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcNotice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 29.75C21.1 29.75 22 28.85 22 27.75H18C18 28.85 18.9 29.75 20 29.75ZM26 23.75V18.75C26 15.68 24.37 13.11 21.5 12.43V11.75C21.5 10.92 20.83 10.25 20 10.25C19.17 10.25 18.5 10.92 18.5 11.75V12.43C15.64 13.11 14 15.67 14 18.75V23.75L12 25.75V26.75H28V25.75L26 23.75ZM24 24.75H16V18.75C16 16.27 17.51 14.25 20 14.25C22.49 14.25 24 16.27 24 18.75V24.75Z",
    fill: "#3D454D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotice);
export default __webpack_public_path__ + "static/media/ic_notice.572119547f2188fe02889e92d2b88596.svg";
export { ForwardRef as ReactComponent };